import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../components/LanguageContext';
import Nav from '../components/Nav';
import Form from '../components/FormBlock';
import Footer from '../components/Footer';
import ImageAbout from '../image/ImageAbout';

const AboutPage = () => {
  const { language, translations } = useLanguage();
  const [activeBlock, setActiveBlock] = useState(0);
  const location = useLocation();

  const images = [
    ImageAbout.image11, ImageAbout.image22, ImageAbout.image33, ImageAbout.image44,
    ImageAbout.image55, ImageAbout.image66, ImageAbout.image77, ImageAbout.image88,
    ImageAbout.image99, ImageAbout.image10, ImageAbout.image111, ImageAbout.image12,
  ];

  const sectors = [
    "construction_and_infrastructure", "medical_goods_and_services", "education_and_culture",
    "it_and_digitalization", "energy", "transportation", "defense_and_security",
    "utilities_and_public_services", "agricultural_sector", "social_services",
    "communication_and_telecommunications", "science_and_innovation",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const t = translations['translations.json']?.about || {};

  const renderTextWithStyles = (text) => {
    if (!text) return null;
    const keywords = ['Education', 'Experience', 'Languages', 'Location'];
    return text.split('\n').map((line, index, array) => {
      const parts = line.split(new RegExp(`(${keywords.join('|')})`, 'g')).map((part, i) => {
        if (keywords.includes(part)) {
          return <span key={i} style={{ fontWeight: 700 }}>{part}</span>;
        }
        return part;
      });
      return (
        <React.Fragment key={index}>
          {parts}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="content_container">
      <Nav />
      <div className="container">
        <div className="about_container">
          <h1 className="about_header-title">{t.title?.[language]}</h1>
          <p className="about_descr-title">{renderTextWithStyles(t.description?.[language])}</p>
        </div>
        <div className="about_bottom-descr">
          <h2>{t.what_we_do?.title?.[language]}</h2>
          <p className="about_descr">{renderTextWithStyles(t.what_we_do?.description?.[language])}</p>
        </div>
        <div className="image_text-container">
          <div className="image_item">
            <img src={images[activeBlock]} alt={`Image ${activeBlock + 1}`} className="active_image" />
          </div>
          <div className="text_item-about">
            {sectors.map((sector, index) => (
              <div key={index} className="text_col-about" onMouseEnter={() => setActiveBlock(index)}>
                <p className="descr_title-about">{t.sectors?.[sector]?.title?.[language]}</p>
                <p className="descr_text-about">{renderTextWithStyles(t.sectors?.[sector]?.description?.[language])}</p>
              </div>
            ))}
          </div>
        </div>
        <Form />
        <Footer />
      </div>
    </div>
  );
};

export default AboutPage;